// extracted by mini-css-extract-plugin
export var resizer = "_ie-0";